<template>
    <div class="page-wrap">
        <!-- <div class="page-loading" v-if="pageIn">
            <van-loading type="spinner" size="34px" vertical>正在加载…</van-loading>
        </div> -->
        <!-- banner样式 -->
        <div class="page-banner">
            <div class="page-banner-bg" v-if="!isShow"><img src="https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_bg_s.png" alt=""></div>
            <div class="page-banner-bg" v-else><img src="https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_bg_big_1_s.png" alt=""></div>
            <div class="page-banner-content">
                <button v-if="!isH5 && isShowShare" class="page-banner-content-share" @click.stop.prevent="shareOpen"></button>
                <h1 class="page-banner-title">趋势精选股票池</h1>
                <div class="page-banner-box">
                    <div class="page-banner-left">
                        <p class="page-banner-time" v-if="dateStr">{{dateStr}}更新</p>
                        <div @click.stop.prevent="isShow = !isShow" :class="{bindShow: isShow}">
                            <span></span><button></button><i></i>
                        </div>
                    </div>
                    <div :class="['page-banner-right', {isTop: !isShow}]">
                        <button class="page-banner-only">会员剩余日期:{{days}}天</button>
                        <span class="page-banner-line"></span>
                        <button class="page-banner-btn" @click.stop.prevent="renewFn">{{ not_vip ? '开通' : '续费'}}</button>
                    </div>
                </div>
                <div class="page-banner-text" v-if="isShow">
                    <p>根据大数据多维度选出正处于上升趋势，成交量和市场关注度较高，中线热门题材，主流机构和量化资金抱团的活跃股。每日收盘后一小时内更新。</p>
                    <p v-if="false">产品证书号：A0690621010001</p>
                </div>
            </div>
        </div>

        <!-- 轮播 战绩榜 swiper-no-swiping 禁止手动滑动 -->
        <div class="top-stock-list-wrap" v-if="top_list.length > 0">
            <div class="top-stock-list swiper2">
                <div class="swiper-container">
                    <div class="swiper-wrapper swiper-no-swiping">
                        <div
                            class="swiper-slide"
                            v-for="(item, i) in top_list"
                            :key="'ing_' + i"
                        >
                        <span class="top-stock-list-item"
                            :data-stock="item.code"
                            :data-name="item.name"
                        >{{ item.text }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="top-stock-list-under"></div>
        </div>


        <!-- 股票数 -->
        <div class="page-stock-num">
            <p v-if="currentTimeFn()">{{not_vip && !codeLen ? '--' : codeLen}}只股票入选</p>
            <p v-else>{{not_vip && !codeLen ? '--' : codeLen}}只股票入选</p>

            <div class="page-stock-picker" @click.stop.prevent="showTab" v-if="currentTime">
                <span class="page-stock-picker-icon"></span>
                <span class="page-stock-picker-time">{{currentDaFn()}}</span>
                <span class="page-stock-picker-day">{{currentDayFn}}</span>
                <span class="page-stock-picker-arrow"></span>
            </div>
        </div>
        <!-- 股票列表 -->
        <div class="page-stock-wrap">

            <!-- 顶部样式 -->
            <div :class="['sticky_top', isSource]">
                <!-- 左侧固定列 -->
                <div class="sticky_top_left">
                    <div v-for="(item, index) in tabs" :key="index">{{item.name}}</div>
                </div>
                <!-- 右侧滚动区域（表头：overflow hidden + 内层 transform 跟随数据区，避免 scrollLeft 同步引发的回流） -->
                <div
                    class="sticky_top_right"
                    ref="rightBoxHead"
                >
                    <div ref="rightBoxHeadInner">
                        <div
                            v-for="(item, index) in tabs_1" 
                            :key="index"
                            :class="[{
                                isSortAble: item.sortable,
                                isDesc: item.sortable && defaultSortTable == item.type && defaultSortType == 'desc',
                                isAsc: item.sortable && defaultSortTable == item.type && defaultSortType == 'asc',
                                isPadL: item.isPadL,
                                isLitWidth: item.isLitWidth,
                                isAnalysis: item.isAnalysis,
                                isSpWidth: item.isSpWidth
                                // isCenter: item.isCenter
                            }]"
                            @click.stop.prevent="sortFn(item, index)"
                        >
                            <span v-if="item.nameLines" class="cell-name">
                                <em v-for="(line, li) in item.nameLines" :key="li">{{line}}</em>
                            </span>
                            <template v-else>{{item.name}}</template>
                            <span v-if="item.sortable">
                                <i></i>
                                <i></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 主体样式 -->
            <div class="sticky_bottom">
                <!-- 左侧固定列 -->
                <div class="sticky_bottom_left">
                    <div>
                        <div 
                            v-for="(lItem, lIndex) in sortableList" 
                            :key="lIndex"
                            @click.stop.prevent="goDetail(lItem)"
                        >
                            {{lItem['name']}}
                        </div>
                    </div>
                </div>
                <!-- 右侧滚动区域 -->
                <div
                    class="sticky_bottom_right"
                    @scroll="divScroll"
                    ref="rightBoxContent"
                >
                    <div 
                        v-for="(item, index) in sortableList"
                        :key="index"
                    >
                        <div
                            v-for="(lItem, lIndex) in tabs_1" 
                            :key="lIndex"
                            :class="[{
                                isRed: lItem.isColor && item['chg_pct'] > 0,
                                isGreen: lItem.isColor && item['chg_pct'] < 0,
                                isCenter: lItem.isCenter,
                                isLitWidth: lItem.isLitWidth,
                                isAnalysis: lItem.isAnalysis,
                                isPadL: lItem.isPadL,
                                isSpWidth: lItem.isSpWidth
                            }]"
                            @click.stop.prevent="goDetail(item, lItem.type)"
                        >
                            <template v-if="lItem.isAnalysis">
                                <span class="analysis-tag">解析</span>
                            </template>
                            <template v-else>{{ stampFn(item, lItem) }}</template>
                        </div>
                    </div>
                </div>
            </div>

            <span class="page-stock-tip" v-if="isFix"></span>
        </div>
        <div class="default-wrapper" v-if="loaded && sortableList && sortableList.length > 0">
            <p class="tips">没有更多了</p>
          </div>
        
        <div v-else-if="loaded && sortableList && sortableList.length == 0 && not_vip" class="empty_st">
            <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/Frame11.svg" alt="">
            <div @click.stop.prevent="renewFn" class="btn">立即开通 查看今日股票池</div>
        </div>

        <div v-else-if="loaded && sortableList && sortableList.length == 0 && !not_vip" class="empty_st">
            <img src="https://cdncos.aigupiao.com/assets/wap/img/stockPool/empty.png" alt="">
            <p>{{loading? "加载中……": "暂无符合条件的股票"}}</p>
        </div>

        <div class="page-stock-footer">上述股票池仅供参考，并不保证收益。据此操作，风险自担。</div>

        <!-- 底部工具栏 -->
        <div class="page-stock-toolbar">
            <div class="toolbar-item" @click="openChangePopup">
                <p class="toolbar-text toolbar-change">本次变动<span class="toolbar-num">{{changeCount}}</span></p>
            </div>
            <div class="toolbar-item" @click="openUnfollowPopup">
                <p class="toolbar-text toolbar-unfollow">不再关注<span class="toolbar-num toolbar-num-gray">{{unfollowCount}}</span></p>
            </div>
            <div class="toolbar-item" @click="shareOpen" v-if="false">
                <p class="toolbar-text toolbar-notice toolbar-btn">更新提醒</p>
            </div>
        </div>

        <!-- 日历 -->
        <van-calendar
            v-if="minDate"
            type="single"
            v-model="show" 
            :default-date="currentTime"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :show-confirm="false"
            @confirm="checkDate"
        />

        <!-- 本次变动弹窗 -->
        <van-popup v-model="showChangePopup" position="bottom" round class="change-popup" :close-on-click-overlay="true">
            <div class="change-popup-head">
                <p class="change-popup-title">本次变动</p>
                <img class="change-popup-close" @click="showChangePopup = false"  src="https://cdncos.aigupiao.com/assets/wap/svg/stockpool/close.svg" alt="">
            </div>

            <!-- 首次加载中 -->
            <div class="popup-loading" v-if="changeLoading">
                <div class="popup-spinner"></div>
                <p>加载中...</p>
            </div>

            <!-- 内容（一次性全量展示） -->
            <div class="change-popup-body" v-else>
                <div class="change-popup-section">
                    <p class="change-popup-section-title add">较昨日新增（{{changeData.add.length}}）</p>
                    <div class="change-popup-tags">
                        <span class="change-popup-tag" v-for="(item, index) in changeData.add" :key="'add_' + index" @click="goStockQuote(item)">{{item.name}}</span>
                    </div>
                </div>

                <div class="change-popup-section">
                    <p class="change-popup-section-title remove">较昨日移除（{{changeData.remove.length}}）</p>
                    <div class="change-popup-tags">
                        <span class="change-popup-tag" v-for="(item, index) in changeData.remove" :key="'remove_' + index" @click="goStockQuote(item)">{{item.name}}</span>
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 不再关注弹窗 -->
        <van-popup v-model="showUnfollowPopup" position="bottom" round class="unfollow-popup" :close-on-click-overlay="true">
            <div class="unfollow-popup-head">
                <p class="unfollow-popup-title">不再关注</p>
                <img class="unfollow-popup-close" @click="showUnfollowPopup = false"  src="https://cdncos.aigupiao.com/assets/wap/svg/stockpool/close.svg" alt="">
            </div>

            <!-- 移出原因提示条 -->
            <div class="unfollow-popup-reason">
                <img src="https://cdncos.aigupiao.com/assets/wap/svg/stockpool/tips.svg" alt="">
                <p>移出原因：跌破20日均线或者跌破上升趋势线，不符合样本要求</p>
            </div>

            <!-- 首次加载中 -->
            <div class="popup-loading" v-if="unfollowLoading">
                <div class="popup-spinner"></div>
                <p>加载中...</p>
            </div>

            <!-- 表格（一次性全量展示） -->
            <div class="unfollow-popup-table" v-else>
                <div class="unfollow-popup-table-head">
                    <span class="col-name">名称</span>
                    <span class="col-perf">移出后表现</span>
                    <span class="col-time">移出时间</span>
                </div>
                <div class="unfollow-popup-table-body">
                    <div class="unfollow-popup-row" v-for="(item, index) in unfollowData" :key="index" @click="goStockQuote(item)">
                        <span class="col-name">{{item.name}}<em>（{{item.symbol}}）</em></span>
                        <span
                            class="col-perf"
                            :class="{
                                isRed: item.exit_pct > 0,
                                isGreen: item.exit_pct < 0
                            }"
                        >{{ formatExitPct(item.exit_pct) }}</span>
                        <span class="col-time">{{formatExitDate(item.exit_date)}}</span>
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 更新提醒设置弹窗 -->
        <van-popup v-model="showNoticePopup" position="bottom" round class="notice-popup" :close-on-click-overlay="true">
            <div class="notice-popup-head">
                <p class="notice-popup-title">更新提醒设置</p>
                <img class="notice-popup-close" @click="showNoticePopup = false"  src="https://cdncos.aigupiao.com/assets/wap/svg/stockpool/close.svg" alt="">
            </div>

            <!-- 每日更新提醒卡片 -->
            <div class="notice-popup-card">
                <div class="notice-popup-card-info">
                    <p class="notice-popup-card-title">每日更新提醒</p>
                    <p class="notice-popup-card-desc">股票池更新后通知我</p>
                </div>
                <div class="notice-popup-switch" :class="{on: noticeSwitchOn}" @click="noticeSwitchOn = !noticeSwitchOn">
                    <span class="notice-popup-switch-dot"></span>
                </div>
            </div>

            <!-- 底部提示 -->
            <p class="notice-popup-tip">关闭后，你将不会收到股票池每日更新的提醒通知，但仍可在应用内查看最新名单。</p>
        </van-popup>

        <div class="tanc_w" v-show="show_tip">
            <div class="tanc">
                <svg @click="show_tip = false;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.63402 4.3513L15.9314 15.6487M4.06833 15.6487L15.3657 4.3513" stroke="#888888" stroke-width="1.6" stroke-linecap="round"/>
                </svg>
                <p class="tanc_fb margin8">{{show_data.stock_name}}（{{show_data.symbol}}）</p>
                <p class="margin8">现价：<span class="tanc_red">{{show_data.last_price}}  +{{show_data.chg_pct}}%</span> </p>
                <p class="margin8">30天入选：<span class="tanc_red">{{show_data.select_number}}次</span> </p>
                <div class="ckhq tanc_red2" @click="goDetail({
                    code:show_data.code,
                    name:show_data.stock_name,
                })">
                    查看行情
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                        <path d="M1.37971 9.82031L5.62028 5.37953L1.37971 1.17969" stroke="#FF443D" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="rxls">
                    <div class="r_l"></div>
                    <span  class="tanc_fb span">入选历史</span>
                    <div class="r_l"></div>
                </div>

                <div class="rxls_box">
                    <div class="rxls_item">
                        <span class="tanc_c63">入选时间</span>
                        <span class="tanc_c63">历史推荐</span>
                    </div>
                    <div class="rxls_item" v-for="(item, index) in show_data.list" :key="index">
                        <span>{{item.date_ymd}}</span>
                        <span class="tanc_b" @click="showHistory(item)">
                            {{ not_vip && dateStr.includes(item.date_ymd) ? '开通后查看' : '查看' }}
                        </span>
                    </div>
                </div>

                <div class="kt_btn" v-if="not_vip"  @click.stop.prevent="renewFn">
                    立即开通
                </div>
            </div>
        </div>
        <!-- // href="http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=sh600498&name=烽火通信" -->
    </div>
</template>
<script>
import { appversion } from "@/utils/urlQuery";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
    name: "stockPool",
    data() {
        return {
            Authorization:decodeURI(this.$route.query.Authorization) ,
            from: this.$route.query.from || '',
            tabs: [
                // {
                //     name: "代码",
                //     type: "code"
                // }, 
                {
                    name: "名称",
                    type: "name"
                }
            ],
            defaultSortTable: "chg_pct",
            defaultSortType: "desc",
            tabs_1: [
                {
                    name: "现价",
                    type: "last",
                    isColor: true,
                }, {
                    name: "涨跌幅",
                    type: "chg_pct",
                    isColor: true,
                    sortable: true,
                    sortType: "desc",
                    isPercentage: true,
                    isSpWidth: true
                }, {
                    // nameLines 拆成两行标题，避免用 \n + pre-line（会被模板缩进空白干扰）
                    name: "30天入选",
                    nameLines: ["30天", "入选"],
                    type: "count_within_30",
                    isUnit: true,
                    sortable: true,
                    isLitWidth: true
                }, {
                    name: "解析",
                    type: "analysis",
                    isAnalysis: true,
                    isCenter: true,
                }, {
                    name: "所属板块",
                    type: "theme_name",
                    isText: true,
                    isPadL: true,
                }, {
                    name: "成交额",
                    type: "amount",
                    sortable: true,
                    sortType: "",
                    isConversion: true,
                }, {
                    name: "换手率",
                    type: "turnover_rate",
                    sortable: true,
                    sortType: "",
                    isPercentage: true,
                }, {
                    name: "总市值",
                    type: "whole",
                    sortable: true,
                    sortType: "",
                    isConversion: true,
                }
            ],
            list: [],
            isFix: true,
            circleId: null, // 圈子ID
            dateStr: "",
            codeLen: 0,
            isShow: false,
            loaded: false,
            cureentDefault: "", // 环境
            days: 0, // 
            show: false,
            minDate: "",
            maxDate: "",
            currentTime: "", // 当前事件
            today: "",


            date:this.$route.query.date,//传参
            not_vip:false,//非会员
            show_tip:false,//弹窗
            show_data:{},//弹窗数据
            showChangePopup:false,//本次变动弹窗
            changeLoading:false,//本次变动加载中
            changeLoaded:false,//本次变动数据是否已拉取（缓存标记）
            changeCount:0,//本次变动数量（新增+移除总数）
            changeData:{//本次变动数据
                add:[],
                remove:[]
            },
            showUnfollowPopup:false,//不再关注弹窗
            unfollowLoading:false,//不再关注加载中
            unfollowLoaded:false,//不再关注数据是否已拉取（缓存标记）
            unfollowCount:0,//不再关注数量
            unfollowData:[],//不再关注数据
            showNoticePopup:false,//更新提醒设置弹窗
            noticeSwitchOn:true,//每日更新提醒开关状态（true=开）

            //战绩榜数据
            top_list:[],
            swiper2:null,
            disTimeArr: [],
            pageIn: true, // 页面进入后
            loading: false,
            isSource: "", // 版本
            isIos: false,
            userInfo: null,
            isH5: false,
            isShowShare: false,
        }
    },
    mounted() {
        let _this = this;
        $('body').on('click','.top-stock-list-item',function(){
            let code = $(this).attr('data-stock');
            _this.openDetail(code)
        })

        window.srNativeCallH5Method = (data) => {
            let params = null;
            params = handleSpecialCharacters(data);
            let obj = {};
            if(params && params.params) {
                obj = params.params;
            }
            if(params.method_name == 'srShare'){
                _this.shareOpen();
            }
        };

        function handleSpecialCharacters(jsonStr) {
            let obj = {};
            if (jsonStr && Object.prototype.toString.call(jsonStr) == "[object String]" && jsonStr != 'null') {
                jsonStr = jsonStr.replace(/\n/g, "\<br/>");
                obj = JSON.parse(jsonStr)
            }
            return obj;
        }
    },
    created() {
        if(location.pathname == '/up/h5/stockPool') {
            this.isH5 = true;
        } else {
            this.isH5 = false;
            this.initApi();
            let APVERSION = appversion || "1000";
            if(APVERSION) {
                if(APVERSION.indexOf(".")>-1) {
                    APVERSION = APVERSION.split(".").join('')
                }
            }

            if(APVERSION < 1310) {
                this.isShowShare = true;
            } else if(false){
                // followup_url
                this.$srH5CallNativeMethodApp('nav_show_more', {
                    is_show: "yes"
                })
            }
        }
        
    },
    
    watch: {
      '$store.state.user': {
        immediate: true,
        deep: true,
        handler(val, oldVal) {
          if(val.userId && val.user_app_token && !this.user_id && !this.userInfo) {
            this.userInfo = val;
          }

          
          if(location.pathname == '/up/h5/stockPool') {
            this.Authorization = "Bearer " + val.user_app_token
            this.initApi();
          }
        }
      }
    },
    methods: {
        shareOpen() {
            // followup_url
            this.$srH5CallNativeMethodApp('share_wx_link', {
                url: location.origin + "/StockPool/index", // /up/h5/stockPool
                type: "", // TODO 等待新版在加上 stock_pool
                title: "趋势精选-热点优选股票池",
                content: "根据大数据多维度选出正处于上升趋势，成交量和市场关注度较高，中线热题材，主流机构和量化资金抱团的活跃股。"
            })
        },
        initApi() {
            var u = navigator.userAgent,
                app = navigator.appVersion;
            var data = null;
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            let isSource = ""
            if (isAndroid) {
                isSource = 'app_versions_android'
            } else if (isiOS) {
                this.isIos = true;
                isSource = 'app_versions_ios'
            }
            console.info(this.isIos,'isIos')
            this.isSource = isSource;
            let today = new Date();
            today.setHours(0);
            today.setMinutes(0);
            today.setSeconds(0);
            today.setMilliseconds(0);

            this.today = today;
            console.log('today',today)

            if(this.date){
                this.currentTime = new Date(this.date);
            }
            else{
                this.currentTime = today;
            }

            
            this.maxDate = today;

            this.minDate = new Date(new Date().getTime() - 30 * 24 * 60 * 60 * 1000)

            let _host = location.host, _currentDefault;
            if(_host.indexOf("dev") > -1 || _host.indexOf("808") > -1) {
                _currentDefault = "dev"
            } else if(_host.indexOf("beta") > -1 ) {
                _currentDefault = "beta"
            } else {
                _currentDefault = ""
            }

            this.cureentDefault = _currentDefault;
            // 校验趋势精选是否签约（header 传 jwt token），未签约先跳签约链接再进页面
            this.checkStockPoolSignFn((canLoad) => {
                // 已签约 / 校验失败均不拦截
                if(canLoad === false) return;
                // 获取列表
                this.getStockPoolFn('save');
                this.getTopData();
            });
        },
        showHistory(item){
            //判断日期是否是最新时间
            if(this.not_vip && this.dateStr.includes(item.date_ymd)){
                this.renewFn();
            }
            else{
                this.show_tip = false;
                this.checkDate(new Date(item.date_ymd));
            }
            
        },
        openDetail(code){
            let _this = this;
            //股票池战绩榜轮播信息
            //appbeta.aigupiao.com/goapi/stock/get_stock_pool_detail 
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool_detail`,
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                data:{stock:code},
                error: function(){return false;},
                success:function(res){
                    console.info(res,'__rse3')
                    if(res.code == 1){
                        _this.show_tip = true;
                        _this.show_data = res.data;
                        _this.show_data.code = code;
                    }
                    
                    
                }
            })
        },
        // 横向滚动：数据区原生滚动，表头内层用 transform 跟随（GPU 合成，不触发回流/重排，减少卡顿）
        divScroll(event) {
            // 非 rAF 环境下直接同步一次
            if(!window.requestAnimationFrame) {
                this.syncHeadScroll(event.target.scrollLeft);
                return;
            }
            if(this._scrollRaf) return;
            this._scrollRaf = window.requestAnimationFrame(() => {
                this._scrollRaf = null;
                this.syncHeadScroll(event.target.scrollLeft);
            });
        },
        syncHeadScroll(sl) {
            if(this.$refs.rightBoxHeadInner) {
                this.$refs.rightBoxHeadInner.style.transform = 'translateX(' + (-sl) + 'px)';
            }
        },
        getTopData(){
            let _this = this;
            //股票池战绩榜轮播信息
            //https://apidev.stock-ring.com/goapi/stock/stock_pool_rank
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://api${_this.cureentDefault}.stock-ring.com/goapi/stock/stock_pool_rank`,
                cache: false,
                async: true,
                error: function(){return false;},
                success:function(res){
                    console.info(res,'__-rse2')
                    _this.top_list = res.data;
                    _this.swiper();
                }
            })
        },
        swiper(){
            //战绩榜 滚动事件
            if(this.swiper2){
                //清楚 已有滚动
                this.swiper2.destroy(true);
            }
            if(this.top_list.length > 1){
                this.$nextTick(() => {
                    this.swiper2 = new Swiper(".swiper-container", {
                        autoplay: {
                                delay: 5000,
                                disableOnInteraction: false,
                            },
                            loop: true,
                            direction: 'vertical',
                    });
                });
            }
        },
        formatter(day) {
            let _date = new Date(day.date);
            let disTimeArr = this.disTimeArr, _m = _date.getMonth() + 1, _y = _date.getFullYear(), _d = _date.getDate();
            _m = _m < 10? '0' + _m: _m;
            _d = _d < 10? '0' + _d: _d;
            if(disTimeArr.indexOf(_y + '-' + _m + '-' + _d) > -1) {
                // console.info('rua')
            } else {
                day.type = 'disabled'
            }
            return day
        },
        showTab() {
            this.show = true;
        },
        checkDate(day) {
            console.log('day',day);
            this.show = false;
            this.currentTime = day;
            this.list = [];
            this.loading = true;

            // 切换日期：重置缓存并重新静默预取两个数字
            this.changeLoaded = false;
            this.unfollowLoaded = false;
            this.preloadPopupData();

            setTimeout(()=>{
                this.getStockPoolFn('load')
            }, 250)
        },
        stampFn(lItem, item) {
            let _str = ""
            // 解析列：无数据时渲染空，避免 NaN
            if(item.isAnalysis) {
                return this.hasAnalysis(lItem) ? "解析" : "";
            }
            // 单位转换 - 亿 万
            if(item.isConversion) {
                let _val = lItem[item.type];
                let lItemVal = Math.abs(_val)
                if (lItemVal > 99999999) {
                    _str = (_val / 100000000).toFixed(2) + "亿";
                } else if (lItemVal > 9999) {
                    _str = (_val / 10000).toFixed(2) + "万";
                } else if (lItemVal == "--") {
                    _str = "0";
                } else {
                    _str = _val + "";
                }
            }
            // 是否开启了 百分比转换
            else if(item.isPercentage) {
                _str = (lItem[item.type] * 1).toFixed(2) + "%"
            }
            // 是否有单位次数
            else if(item.isUnit) {
                _str = (lItem[item.type] * 1) + '次'
            }
            // 是否要纯文字展示
            else if(item.isText) {
                _str = lItem[item.type];
            }
            else {
                _str = (lItem[item.type] * 1).toFixed(2);
            }
            return _str;
        },
        // 滚动方法
        scrollFn() {
            if($(this.$refs['page-stock-right']).scrollLeft() > 0) {
                this.isFix = false;
            }
            else {
                this.isFix = true;
            }
        },
        // 排序
        sortFn(item, index) {
            if(item.sortable) {
                if(item.type == this.defaultSortTable) {
                    if(this.defaultSortType == "desc") {
                        this.defaultSortType = "asc";
                    } else if(this.defaultSortType == "asc"){
                        this.defaultSortType = "desc"; 
                    }
                } else {
                    this.defaultSortType = "desc";
                    this.defaultSortTable = item.type;
                }
            }
        },
        // 跳转详情页
        goDetail(item, type) {
            if(type == "count_within_30") {
                this.openDetail(item.code)
                return
            }
            if(type == 'theme_name') {
                var u = navigator.userAgent;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_jump_kind=theme&jump_id=${item.theme_id}`;    
                } else if (isiOS) {
                    location.href = `http://quote.aigupiao.com/stock_m.php#igpFunToAppJump_kind=theme&jump_id=${item.theme_id}`; 
                }
            } else if(type == "analysis") {
                this.chatWithXiaoAi(item);
            } else {
                location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${item.code}&name=${item.name}`;
            }
            
        },
        // 与小爱老师对话（解析列点击跳转）
        chatWithXiaoAi(item) {
            if(!item) return;
            const targetName = item.name || item.code || '';
            const question = `分析一下${targetName}当前行情和后续关注点`;
            this.$srJumpToNative("AGPAI", question);
        },
        // 是否有当日的强势股解析文章
        hasAnalysis(item) {
            if(!item) return false;
            return !!(item.analysis_article || item.analysis_article_id || item.analysis_id || item.has_analysis || item.analysis_url || item.msg_id)
        },
        // 校验趋势精选是否签约：未签约则跳转签约链接
        // 接口返回 data.is_sign：yes 已签约 / no 未签约（未签约时 data.sign_url 为签约链接）
        checkStockPoolSignFn(callback) {
            let _this = this;
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool_order_sign`,
                cache: false,
                async: true,
                beforeSend: function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function() {
                    // 校验失败不拦截，继续正常加载页面
                    if(callback) callback(true);
                },
                success: function(res) {
                    // 未签约且返回了签约链接 -> 直接跳转签约
                    if(res && res.code == 1 && res.data && res.data.is_sign == 'no' && res.data.sign_url) {
                        _this.$srGoZFSign(res.data.sign_url);
                        return;
                    }
                    if(callback) callback(true);
                }
            });
        },
        // 获取股票池列表
        async getStockPoolFn(type) {
            let _this = this;
            let data = {};
            // 只要当前选中的日期不是「今天」，就显式传 date_ymd
            // （后端不传日期 = 查今天；当最新数据日不是今天时，必须传日期才能查到数据）
            if(this.currentDaFn() !== this.todayDaFn()) {
                data.date_ymd = this.currentDaFn()
            }
            console.info(this.$store.state.user.user_app_token, '$store')
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'post',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool`,
                data,
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function(){return false;},
                success:function(res){
                    if(!data.date_ymd && _this.from == 'applink' && (res.data.is_vip == 'no' || (res.code != 1 && res.message!="仅会员支持查看趋势精选")) && res.data.stock_pool_list.length == 0) {
                        location.href = `${location.origin}/StockPool/index?u_id=${_this.$route.query.agp_u_id || _this.$route.query.u_id || _this.$route.query.user_id || ''}&kind=QSJX&Authorization=${_this.Authorization}`
                        return
                    }
                    // 请求成功
                    if(res.code == 1 || res.message=="仅会员支持查看趋势精选") {
                        _this.not_vip = res.data.is_vip == 'no' ? true : false;

                        _this.list = res.data.stock_pool_list;
                        
                        let _empty = [];
                        for(let i=0,ilen=res.data.stock_pool_date_list.length;i<ilen;i++) {
                            _empty.push(res.data.stock_pool_date_list[i]['day'])
                        }

                        if(_this.list.length == 0 && !data.date_ymd) {
                            // _this.checkDate();
                        }
                        //更新 时间显示可能有问题
                        _this.dateStr = res.data.update_time;
                        if(type == 'save') {
                            _this.dateStr = res.data.update_time;
                            if(!data.date_ymd && _empty.indexOf(_this.dateStr) == -1 && res.data.stock_pool_length > 0) {
                                _empty.unshift(_this.dateStr)
                            }
                            _this.disTimeArr = _empty;
                            _this.maxDate = new Date(_empty[0].replace(/-/g,'/'));
                            _this.minDate = new Date(_empty[_empty.length-1].replace(/-/g,'/'));
                            
                            if(_this.date){
                                
                            }
                            else{
                                _this.currentTime = _this.maxDate;
                            }
                            
                            // 今天无数据（数据最新日不是今天）时，首次不传日期进入返回的列表为空，
                            // 自动切到最新数据日重查一次，保证首次进入也能展示最新一期数据
                            if(!data.date_ymd && res.data.stock_pool_list.length == 0 && _empty.length > 0) {
                                _this.getStockPoolFn('load');
                            }

                            // _this.pageIn = false;
                            _this.$nextTick(()=>{
                                if(window.__hideSPLoading) {
                                    window.__hideSPLoading();
                                } else {
                                    let _loading = document.getElementsByClassName("w_page-loading")[0]
                                    _loading.style.display = "none"
                                }
                            })
                        }
                        _this.codeLen = res.data.stock_pool_length
                        _this.days = res.data.vip_day_num;

                        // 列表成功后静默预取两个数字（本次变动 / 不再关注）
                        if(type == 'save') {
                            _this.preloadPopupData();
                        }
                    } else {
                        if(type == 'save') {
                            _this.$nextTick(()=>{
                                if(window.__hideSPLoading) {
                                    window.__hideSPLoading();
                                } else {
                                    let _loading = document.getElementsByClassName("w_page-loading")[0]
                                    _loading.style.display = "none"
                                }
                            })
                        }
                        _this.not_vip = true;
                    }
                    _this.loaded = true;
                    _this.loading = false;
                }
            })
        },
        // 打开本次变动弹窗（先展示弹窗+转圈，再请求接口）
        openChangePopup() {
            this.showChangePopup = true;
            if(this.changeLoaded) {
                // 已预取到数据，直接展示
                return;
            }
            if(this.changeLoading) return;
            this.changeLoading = true;
            this.getChangeData();
        },
        // 获取本次变动数据（一次性全量返回；silent=true 静默预取不弹 loading）
        getChangeData(silent) {
            let _this = this;
            if(!silent) {
                _this.changeLoading = true;
            }
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool_diff`,
                data: {
                    date_ymd: _this.currentDaFn()
                },
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function(){
                    _this.changeLoading = false;
                },
                success:function(res){
                    _this.changeLoading = false;
                    if(res.code == 1) {
                        let d = res.data || {};
                        _this.changeData.add = d.added_list || [];
                        _this.changeData.remove = d.removed_list || [];
                        _this.changeCount = (d.added_list ? d.added_list.length : 0) + (d.removed_list ? d.removed_list.length : 0);
                    } else {
                        _this.changeData.add = [];
                        _this.changeData.remove = [];
                    }
                    _this.changeLoaded = true;
                }
            })
        },
        // 打开不再关注弹窗（先展示弹窗+转圈，再请求接口）
        openUnfollowPopup() {
            this.showUnfollowPopup = true;
            if(this.unfollowLoaded) {
                // 已预取到数据，直接展示
                return;
            }
            if(this.unfollowLoading) return;
            this.unfollowLoading = true;
            this.getUnfollowData();
        },
        // 获取不再关注数据（一次性全量返回；silent=true 静默预取不弹 loading）
        getUnfollowData(silent) {
            let _this = this;
            if(!silent) {
                _this.unfollowLoading = true;
            }
            $.ajax({ xhrFields: {withCredentials: true},
                type: 'get',
                dataType: 'json',
                url: `https://app${_this.cureentDefault}.aigupiao.com/goapi/stock/get_stock_pool_exit_data`,
                cache: false,
                async: true,
                beforeSend:function (request){
                    request.setRequestHeader("Authorization", _this.Authorization);
                },
                error: function(){
                    _this.unfollowLoading = false;
                },
                success:function(res){
                    _this.unfollowLoading = false;
                    if(res.code == 1) {
                        _this.unfollowData = res.data || [];
                        _this.unfollowCount = _this.unfollowData.length;
                    } else {
                        _this.unfollowData = [];
                    }
                    _this.unfollowLoaded = true;
                }
            })
        },
        // 静默预取两个数字（进入页面 / 切换日期时调用）
        preloadPopupData() {
            this.getChangeData(true);
            this.getUnfollowData(true);
        },
        // 格式化移出日期：2026-10-12 -> 10-12
        formatExitDate(date) {
            if(!date) return '';
            return String(date).slice(5);
        },
        // 格式化移出后表现：统一保留两位小数（0 也展示 0.00）
        formatExitPct(val) {
            if(val === null || val === undefined || val === '' || isNaN(val * 1)) return '--';
            return (val * 1).toFixed(2) + '%';
        },
        // 弹窗内股票跳转行情页（本次变动 / 不再关注通用）
        goStockQuote(item) {
            if(!item) return;
            let code = item.stock_code || item.code || '';
            let name = item.name || '';
            if(!code) return;
            location.href = `http://quote.aigupiao.com/stock_m.php#AiGuPiao_StockCode=${code}&name=${name}`;
        },
        // 点击续费按钮
        renewFn() {
            if(this.isH5) {
                if(this.Authorization && this.userInfo) {
                    this.$downapppop.open('查看');
                    return
                } else {
                    let current = "";
                    if(location.origin.indexOf("dev") > -1) {
                        current = "dev"
                    }
                    this.origin = "https://mobile" + current + ".aigupiao.com"
                    location.href = origin + "/login/index/rd/980880418.html?redirect=" + encodeURIComponent(location.href)
                    return
                }
            }
            let _str = "_str=stockPool#AiGuPiao_ThirdPay";
            if(location.href.indexOf('?') > -1) {
                location.href += ('&'+_str)
            } else {
                location.href += ('?'+_str)
            }
            window.open(_url)
        },
        currentTimeFn() {
            return new Date(this.currentTime).getTime() == new Date(this.maxDate).getTime()
        },
        currentDaFn() {
            let nowDa = new Date(this.currentTime);
            let _y = nowDa.getFullYear();
            let _m = nowDa.getMonth() + 1;;
            let _d = nowDa.getDate();

            _m = _m<10? '0' + _m: _m;
            _d = _d<10? '0' + _d: _d;

            return `${_y}-${_m}-${_d}`
        },
        // 真实今天日期（yyyy-mm-dd），用于判断「选中日期是否是今天」
        todayDaFn() {
            let nowDa = this.today ? new Date(this.today) : new Date();
            let _y = nowDa.getFullYear();
            let _m = nowDa.getMonth() + 1;
            let _d = nowDa.getDate();

            _m = _m<10? '0' + _m: _m;
            _d = _d<10? '0' + _d: _d;

            return `${_y}-${_m}-${_d}`
        },
    },
    computed: {
        sortableList() {
            let list = this.list || [];
            let sort_type = this.defaultSortTable;
            list.sort((a,b)=>{
                if(this.defaultSortType == 'asc') {
                    return a[sort_type] - b[sort_type]
                } else {
                    return b[sort_type] - a[sort_type]
                }
            })
            return list
        },
        currentDayFn() {
            let nowDa = new Date(this.currentTime)
            return '周' + '日一二三四五六'.charAt(nowDa.getDay())
        }
    }
}
</script>
<style scoped lang="scss">
* {
    touch-action: unset;
}
.page-wrap {
    width: 100%;
    height: auto;
    position: relative;
    min-height: 100vh;
    // 纵向 flex：让免责声明在内容不足时也贴底
    display: flex;
    flex-direction: column;
    // 底部为固定工具栏（58px）预留空间，避免最后一条股票被遮挡
    padding-bottom: 58px;
    box-sizing: border-box;
    background-color: #fff;

    // 加载中样式
    .page-loading {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 999;
        background-color: rgba(256, 256, 256,  1);
        display: flex;
        align-items: center;
        justify-content: center;

        .van-loading__text {
            margin-top: 14px;
        }
    }

    .page-banner {
        width: 100%;
        height: auto;
        position: relative;
        overflow: hidden;

        .page-banner-bg {
            width: 100%;
            height: auto;

            img {
                width: 100%;
                height: auto;
                display: block;
            }
        }

        .page-banner-content {
            position: absolute;
            left: 0;
            right: 0;
            width: 100%;
            height: auto;
            top: 40px;

            .page-banner-content-share {
                position: absolute;
                right: 12px;
                top: -24px;
                width: 63px;
                height: 22px;
                background-color: transparent;
                background-image: url("https://cdncos.aigupiao.com/assets/app/svg/shareIcon.svg");
                background-repeat: no-repeat;
                background-size: 100%;
                border: none;
                outline: none;
            }

            .page-banner-title {
                color: #FFFFFF;
                font-size: 22px;
                line-height: 31px;
                padding-left: 12px;
                box-sizing: border-box;
                font-weight: bold;
            }

            .page-banner-box {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-top: 20.5px;
                height: 27px;
                padding-right: 12.5px;
                box-sizing: border-box;

                .page-banner-left {
                    display: flex;
                    flex-direction: row;
                    .page-banner-time {
                        font-size: 13px;
                        line-height: 18.5px;
                        color: #FFFFFF;
                        margin-left: 15px;
                    }

                    div {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        &.bindShow {
                            i {
                                transform: rotate(-180deg);
                            }
                        }
                        
                        span {
                            width: 1px;
                            height: 14px;
                            display: inline-block;
                            background-color: transparent;
                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_line.svg");
                            background-size: 1px 14px;
                            background-repeat: no-repeat;
                            margin-left: 8px;
                        }

                        button {
                            width: 21px;
                            height: 13px;
                            box-sizing: border-box;
                            padding-left: 8.5px;
                            background-color: transparent;
                            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/msg.png");
                            background-size: 12.5px 13px;
                            background-repeat: no-repeat;
                            background-position: 8.5px center;
                            border: none;
                            outline: none;
                        }

                        i {
                            width: 5.5px;
                            height: 4px;
                            background-image: url("https://cdncos.aigupiao.com/assets/app/h5/arrow.png");
                            background-size: 100% 100%;
                            background-repeat: no-repeat;
                            background-position: center center;
                            margin-left: 5px;
                        }
                    }
                }
                .page-banner-right {
                    width: auto;
                    height: auto;
                    background-color: rgba(255, 154, 114, 0.79);
                    border-radius: 5.5px;
                    display: inline-flex;
                    flex-direction: row;
                    align-items: center;
                    padding: 4px 7px 4.5px 8.5px;

                    &.isTop {
                        .page-banner-arrow {
                            background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/icon_top.svg");
                        }
                    }

                    .page-banner-only {
                        padding-left: 3.5px;
                        font-size: 13px;
                        line-height: 18.5px;
                        color: #F5FFCC;
                        border: none;
                        outline: none;
                        background-color: transparent;
                        padding-right: 6px;
                    }

                    .page-banner-line {
                        width: 1px;
                        height: 15.5px;
                        display: inline-block;
                        background-color: transparent;
                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/svg/stock_pool/icon_line.svg");
                        background-size: 1px 15.5px;
                        background-repeat: no-repeat;
                    }

                    .page-banner-btn {
                        background-color: transparent;
                        border: none;
                        font-size: 12px;
                        line-height: 16.5px;
                        color: #F5FFCA;
                        background-image: url("https://cdncos.aigupiao.com/assets/wap/img/stockPool/arrow_1.svg");
                        background-size: 5px 9px;
                        background-repeat: no-repeat;
                        background-position: right;
                        padding-right: 8px;
                        padding-left: 6px;
                    }
                }
            }

            .page-banner-text {
                font-size: 12px;
                line-height: 19px;
                color: #F5FFCA;
                padding: 0 15px;
                margin-top: 16px;
            }
        }
    }

    .page-stock-num {
        height: 41px;
        line-height: 41px;
        width: 100%;
        border-bottom: 0.5px solid #EBEBEB;
        padding-left: 12px;
        padding-right: 10.5px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        p {
            font-size: 14px;
            color: #636363;
        }

        .page-stock-picker {
            width: auto;
            height: 27px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-radius: 5px;
            border: 0.5px solid #DBDBDB;
            padding: 0 8px 0 9.5px;

            .page-stock-picker-icon {
                width: 12.5px;
                height: 12.5px;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/date.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center center;
                margin-right: 4.5px;
            }

            .page-stock-picker-time {
                font-size: 12px;
                height: 27px;
                line-height: 27px;
                color: #939393;
                margin-right: 8px;
            }

            .page-stock-picker-day {
                font-size: 12px;
                height: 27px;
                line-height: 27px;
                color: #939393;
                margin-right: 6px;
            }

            .page-stock-picker-arrow {
                width: 9px;
                height: 5px;
                background-image: url("https://cdncos.aigupiao.com/assets/app/h5/bottom_arrow.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center center;
            }
        }
    }

    .page-stock-wrap {
        width: 100%;
        height: auto;
        /* display: flex;
        flex-direction: row; */

        .page-stock-left {
            display: flex;
            flex-direction: row;
            width: 25%;

            dl {
                overflow: hidden;

                &:first-of-type{
                    flex: 1.4;
                }
                &:last-of-type{
                    flex: 1;
                }
            }
        }

        .page-stock-right {
            display: flex;
            flex-direction: row;
            width: 60%;
            flex: 1;
            overflow: hidden;
            overflow-x: auto;
            position: relative;

            dl {
                min-width: 85px;
                width: 25%;
            }
            
            span {
                &.page-stock-tip {
                    width: 5.5px;
                    height: 9px;
                    position: absolute;
                    right: 10px;
                    top: 16.5px;
                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/arrow.svg");
                    background-repeat: no-repeat;
                    background-size: 100%;
                }
            }
        }

        dl {

            &:first-of-type {
                dt,dd {
                    padding-left: 12.5px;
                }
            }

            dt {
                height: 41px;
                line-height: 41px;
                font-size: 13px;
                color: #636363;
                border-bottom: 0.5px solid #EBEBEB;
                position: relative;


                &.isSortAble {
                    display: flex;
                    flex-direction: row;
                    align-items: center;

                    &.isDesc {
                        span {
                            i {
                                background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                transform: rotate(180deg);

                                &:last-of-type {
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                    transform: rotate(180deg);
                                    margin-top: 3px;
                                }
                            }
                        }
                    }

                    &.isAsc {
                        span {
                            i {
                                background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                transform: rotate(0deg);

                                &:last-of-type {
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                    transform: rotate(0deg);
                                    margin-top: 3px;
                                }
                            }
                        }
                    }

                    span {
                        display: inline-flex;
                        flex-direction: column;
                        margin-left: 3.5px;

                        i {
                            display: inline-block;
                            width: 6.5px;
                            height: 4.5px;
                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                            background-size: 100%;
                            background-repeat: no-repeat;
                            transform: rotate(-180deg);

                            &:last-of-type {
                                transform: rotate(0deg);
                                margin-top: 3px;
                            }
                        }
                    }
                }

                &.isCenter {
                    text-align: center
                }
            }

            dd {
                height: 42px;
                line-height: 42px;
                font-size: 14px;
                color: #333333;
                border-bottom: 0.5px solid #EBEBEB;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                &.isGreen {
                    color: #0AC890;
                    font-weight: bold;
                }

                &.isRed {
                    color: #FE484A;
                    font-weight: bold;
                }

                &.isCenter {
                    // text-align: center;
                    padding-left: 15px;
                    // box-sizing: border-box;
                }
            }
        }

        .sticky_top {
            width: 100%;
            display: flex;
            background-color: #fff;
            border-bottom: .5px solid #ebebeb;

            &.app_versions_android {
                position: sticky;
                top: 0;
                z-index: 10;
            }

            &.app_versions_ios {
                position: sticky;
                top: 0;
                z-index: 10;
            }

            .sticky_top_left {
                display: flex;
                height: 40px;
                line-height: 40px;
                width: 88px;
                font-size: 13px;
                color: #636363;
                padding-left: 12.5px;
                box-sizing: border-box;
            }

            .sticky_top_right {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;

                > div {
                    display: flex;
                    will-change: transform;
                    
                    > div {
                        height: 40px;
                        line-height: 40px;
                        min-width: 78px;
                        width: 25%;
                        font-size: 13px;
                        color: #636363;
                        box-sizing: border-box;

                        &:first-of-type {
                            padding-left: 12.5px;
                        }

                        &.isPadL {
                            padding-left: 8px;
                        }

                        &.isSpWidth {
                            min-width: 70px;
                        }

                        // 窄列：标题多行（如「30天/入选」），整体收窄
                        // 注意：不能用 white-space: pre-line + \n，模板缩进空白会变成空行导致文字不居中
                        &.isLitWidth {
                            min-width: 40px;
                            width: 40px;
                            padding-left: 0;
                            text-align: center;
                            justify-content: center;

                            .cell-name {
                                display: inline-block;
                                margin-left: 0;
                                vertical-align: middle;

                                em {
                                    display: block;
                                    font-style: normal;
                                    line-height: 16px;
                                    white-space: nowrap;
                                }
                            }
                        }

                        // 解析列：内容只有 32px 小标签，列宽单独收窄
                        // 收窄后右侧会露出「所属板块」的第一个字，提示可横向滚动
                        &.isAnalysis {
                            min-width: 52px;
                            width: 52px;
                            padding-left: 0;
                            text-align: center;
                        }

                        &.isSortAble {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
        
                            &.isDesc {
                                span {
                                    i {
                                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                        transform: rotate(180deg);
        
                                        &:last-of-type {
                                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                            transform: rotate(180deg);
                                            margin-top: 3px;
                                        }
                                    }
                                }
                            }
        
                            &.isAsc {
                                span {
                                    i {
                                        background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle_check.svg");
                                        transform: rotate(0deg);
        
                                        &:last-of-type {
                                            background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                            transform: rotate(0deg);
                                            margin-top: 3px;
                                        }
                                    }
                                }
                            }
        
                            span {
                                display: inline-flex;
                                flex-direction: column;
                                margin-left: 3.5px;
        
                                i {
                                    display: inline-block;
                                    width: 6.5px;
                                    height: 4.5px;
                                    background-image: url("https://cdncos.aigupiao.com/assets/aiguquan/img/myPurchase/triangle.svg");
                                    background-size: 100%;
                                    background-repeat: no-repeat;
                                    transform: rotate(-180deg);
        
                                    &:last-of-type {
                                        transform: rotate(0deg);
                                        margin-top: 3px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .sticky_bottom {
            width: 100%;
            display: flex;

            .sticky_bottom_left {
                display: flex;
                
                >div {

                    >div {
                        height: 40px;
                        line-height: 40px;
                        width: 88px;
                        font-size: 14px;
                        color: #333;
                        padding-left: 12.5px;
                        box-sizing: border-box;
                        border-bottom: 0.5px solid #EBEBEB;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }

            .sticky_bottom_right {
                flex: 1;
                white-space: nowrap;
                overflow-x: auto;
                -webkit-overflow-scrolling: touch;
                overscroll-behavior-x: contain;
                contain: layout paint style;

                > div {
                    display: flex;

                    > div {
                        height: 40px;
                        line-height: 40px;
                        min-width: 78px;
                        width: 25%;
                        font-size: 14px;
                        color: #333;
                        border-bottom: 0.5px solid #EBEBEB;
                        position: relative;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        box-sizing: border-box;

                        &:first-of-type {
                            padding-left: 12.5px;
                        }

                        &.isGreen {
                            color: #0AC890;
                            font-weight: bold;
                        }
        
                        &.isRed {
                            color: #FE484A;
                            font-weight: bold;
                        }

                        &.isPadL {
                            padding-left: 8px;
                        }

                        &.isSpWidth {
                            min-width: 70px;
                        }
        
                        &.isCenter {
                            // text-align: center;
                            padding-left: 15px;
                            // box-sizing: border-box;
                        }

                        // 窄列：内容居中且宽度收窄，与表头 .isLitWidth 保持一致
                        &.isLitWidth {
                            min-width: 40px;
                            width: 40px;
                            padding-left: 0;
                            text-align: center;
                        }

                        // 解析列：与表头 .isAnalysis 同宽，标签整体居中
                        &.isAnalysis {
                            min-width: 52px;
                            width: 52px;
                            padding-left: 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .analysis-tag {
                            display: inline-block;
                            width: 32px;
                            height: 21px;
                            line-height: 21px;
                            text-align: center;
                            box-sizing: border-box;
                            background-color: #FEECDA;
                            color: #FF5117;
                            font-size: 12px;
                            font-weight: 400;
                            border-radius: 2px;
                        }
                    }
                }
            }
        }
    }

    .page-stock-footer {
        background-color: #F5F6F7;
        // 内容不足时自动贴底（配合 .page-wrap 的 flex 纵向布局）
        margin-top: auto;
        width: 100%;
        height: 33px;
        line-height: 33px;
        text-align: center;
        font-size: 12px;
        color: #939393;
    }
}
.empty_st {
    padding: 0 60px;

    img {
        width: 100%;
        height: auto;
        display: block;
        margin-top: 25px;
        margin-bottom: 26.5px;
    }

    p {
        font-size: 15px;
        line-height: 21px;
        color: #636363;
        text-align: center;
        user-select: none;
    }

    .btn{
        display: flex;
        height: 40px;
        padding: 0px 18px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
        color: #FFF;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 20px auto;
        box-sizing: border-box;
        width: max-content;
}
}
.default-wrapper {
    text-align: center;
    height: 35px;
  }
  .tips {
    font-size: 12px;
    line-height: 35px;
    color: #999;
  }

  .wrapper {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
  



  .swiper2{
        width: 100%;
        height: 37px;
        line-height: 37px;
    }
    .swiper2 .swiper-container{
        height: 100%;
    }
    .swiper2 .swiper-slide div{
        box-sizing: border-box;
        height: 100%;
        line-height: 200px;
        background-color: lightblue;
        text-align: center;
        border-bottom: 1px solid #e5e5e5;
    }
    .top-stock-list-item{
        padding-left: 44px;
        font-size: 14px;
        font-weight: 400;
        color: #FF5117;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/top-stock-list-item.png) no-repeat;
        background-size: 15px 11px;
        background-position: 10px center;
        position: relative;
        height: 37px;
        line-height: 37px;
        display: inline-block;

        &::before{
            content: "";
            display: block;
            position: absolute;
            width: 1px;
            height: 19px;
            background: #E8E8E8;
            top: 10px;
            left: 33px;
        }
    }
    .top-stock-list-under{
        width: 100%;
        height: 6px;
        background: #F8F8F8;
    }


.tanc_w{
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba($color: #000000, $alpha: .4);
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    color: #333;
}
.tanc{
    width: 265px;
    //height: 379px;
    flex-shrink: 0;
    border-radius: 8px;
    border: 3px solid #EDD8A9;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(180deg, #F7E4C8 0%, #FFF 44.33%);
    padding: 24px;
    box-sizing: border-box;
    position: relative;
}
.tanc >svg{
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    position: absolute;
    top: 16px;
    right: 16px;
}
.tanc_red{
    color: #CB382D;
}
.tanc_red2{
    color: #FF443D;
}
.tanc_c63{
    color: #636363;
}
.tanc_b{
    color: #1D88D0;
}
.tanc_f13{
    font-size: 13px;
}
.tanc_fb{
    font-weight: bold;
}
.ckhq{
    display: flex;
    width: 220px;
    height: 31px;
    justify-content: center;
    align-items: center;
    margin: 10px 0;
    flex-shrink: 0;
    border-radius: 21px;
    border: 1px solid #FF443D;
}
.ckhq >svg{
    width: 6px;
    height: 12px;
    flex-shrink: 0;
    margin-left: 6px;
}
.margin8{
    margin-bottom: 8px;
}
.rxls{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 17px 0;
}
.tanc_fb.span{
    margin: 0 10px;
}
.r_l{
    width: 50px;
    height: 1px;
    background: #EBEBEB;
    background-blend-mode: plus-darker;
}
.rxls_item{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.kt_btn{
    display: flex;
    width: 100%;
    box-sizing: border-box;
    height: 36px;
    justify-content: center;
    align-items: center;
    margin-top: 12px;
    flex-shrink: 0;
    border-radius: 21px;
    background: linear-gradient(180deg, #EB8057 0%, #EC5E3A 100%);
    color: #FFF;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.page-stock-toolbar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    height: 58px;
    background-color: #fff;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-top: 0.5px solid #EDEDF0;

    .toolbar-item {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;

        // tab 之间的分隔线
        & + .toolbar-item::before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 0.5px;
            height: 22px;
            background-color: #EDEDF0;
        }

        .toolbar-icon {
            width: 18px;
            height: 18px;
            flex-shrink: 0;
            margin-right: 6px;
        }

        .toolbar-icon-large {
            width: 22px;
            height: 22px;
        }

        .toolbar-text {
            font-size: 13px;
            line-height: 16px;
            color: #333;
            font-weight: 400;
            background-size: 18px;
            background-repeat: no-repeat;
            background-position: left center;
            padding-left: 24px;

            .toolbar-num {
                color: #BD684A;
                margin-left: 6px;
            }

            .toolbar-num-gray {
                color: #858A94;
                margin-left: 6px;
            }

            &.toolbar-change {
                background-image: url("https://cdncos.aigupiao.com/assets/wap/svg/stockpool/change.svg");
            }

            &.toolbar-unfollow {
                background-image: url("https://cdncos.aigupiao.com/assets/wap/svg/stockpool/unfollow.svg");
            }

            &.toolbar-notice {
                background-image: url("https://cdncos.aigupiao.com/assets/wap/svg/stockpool/notice.svg");
            }
        }
    }
}

/* 本次变动弹窗 */
.change-popup {
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    max-height: 80vh;
    display: flex;
    flex-direction: column;

    .change-popup-head {
        position: relative;
        padding: 20px 16px 0;
        height: 48px;
        box-sizing: border-box;
        flex-shrink: 0;

        .change-popup-title {
            font-size: 16px;
            font-weight: 500;
            color: #000;
            text-align: center;
            line-height: 28px;
        }

        .change-popup-close {
            position: absolute;
            top: 20px;
            right: 16px;
            cursor: pointer;
            width: 22px;
            height: 22px;
        }
    }

    .change-popup-section {
        padding: 0 16px;

        .change-popup-section-title {
            font-size: 14px;
            font-weight: 500;
            line-height: 22px;
            margin-top: 14px;

            &.add {
                color: #FF383C;
            }

            &.remove {
                color: #007AFF;
            }
        }

        .change-popup-tags {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 8px;
            margin-top: 8px;

            .change-popup-tag {
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 7px;
                font-size: 13px;
                font-weight: 400;
                color: #2E3036;
                white-space: nowrap;
            }
        }
    }

    .change-popup-section:first-of-type {
        .change-popup-tags {
            .change-popup-tag {
                background: #FFF6F1;
            }
        }
    }

    .change-popup-section:last-of-type {
        padding-bottom: 24px;

        .change-popup-tags {
            .change-popup-tag {
                background: #F1FAF6;
            }
        }
    }

    .change-popup-body {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 16px;
    }
}

/* 弹窗通用 loading（本次变动 / 不再关注共用） */
.popup-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 0 48px;

    p {
        margin-top: 12px;
        font-size: 13px;
        color: #999;
    }
}

.popup-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f0f0f0;
    border-top-color: #FF383C;
    border-radius: 50%;
    animation: popup-spinner-rotate 0.8s linear infinite;
}

.popup-spinner-sm {
    width: 18px;
    height: 18px;
    border-width: 2px;
}

.popup-more {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0 4px;

    p {
        margin-left: 8px;
        font-size: 12px;
        color: #999;
    }
}

.popup-end {
    color: #BBB;
}

@keyframes popup-spinner-rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* 不再关注弹窗 */
.unfollow-popup {
    border-radius: 12px 12px 0 0;
    overflow: hidden;
    max-height: 80vh;
    display: flex;
    flex-direction: column;

    .unfollow-popup-head {
        position: relative;
        padding: 20px 16px 0;
        height: 48px;
        box-sizing: border-box;
        flex-shrink: 0;

        .unfollow-popup-title {
            font-size: 16px;
            font-weight: 500;
            color: #000;
            text-align: center;
            line-height: 28px;
        }

        .unfollow-popup-close {
            position: absolute;
            top: 20px;
            right: 16px;
            cursor: pointer;
            width: 22px;
            height: 22px;
        }
    }

    /* 移出原因提示条 */
    .unfollow-popup-reason {
        display: flex;
        align-items: flex-start;
        margin: 10px 16px 0;
        padding: 10px 12px;
        background: #F3F7FA;
        border-radius: 8px;
        flex-shrink: 0;

        img {
            flex-shrink: 0;
            margin-right: 8px;
            width: 18px;
            height: 18px;
        }

        p {
            font-size: 13px;
            font-weight: 400;
            color: #858C97;
            line-height: 20px;
        }
    }

    /* 表格 */
    .unfollow-popup-table {
        flex: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        margin-top: 12px;
        padding-bottom: 24px;

        .unfollow-popup-table-head,
        .unfollow-popup-row {
            display: flex;
            align-items: center;
            height: 50px;
            padding: 0 16px;
            box-sizing: border-box;
        }

        .unfollow-popup-table-head {
            border-bottom: 0.5px solid #E7EAF0;

            span {
                font-size: 13px;
                font-weight: 400;
                color: #686E7A;
            }
        }

        .unfollow-popup-row {
            border-bottom: 0.5px solid #E7EAF0;

            &:last-child {
                border-bottom: none;
            }

            .col-name {
                font-size: 14px;
                font-weight: 500;
                color: #18191E;

                em {
                    font-style: normal;
                    font-size: 13px;
                    font-weight: 400;
                    color: #858C97;
                }
            }

            .col-perf {
                font-size: 14px;
                font-weight: 500;
                // 移出后表现：0（及无数据）用灰色
                color: #686E7A;

                // 大于0红色，小于0绿色
                &.isRed {
                    color: #FE484A;
                }

                &.isGreen {
                    color: #0CA85D;
                }
            }

            .col-time {
                font-size: 14px;
                font-weight: 400;
                color: #686E7A;
            }
        }

        .col-name {
            flex: 1;
            text-align: left;
        }

        .col-perf {
            width: 100px;
            text-align: right;
        }

        .col-time {
            width: 60px;
            text-align: right;
        }
    }
}

/* 更新提醒设置弹窗 */
.notice-popup {
    border-radius: 12px 12px 0 0;
    overflow: hidden;

    .notice-popup-head {
        position: relative;
        padding: 20px 16px 0;
        height: 48px;
        box-sizing: border-box;

        .notice-popup-title {
            font-size: 16px;
            font-weight: 500;
            color: #000;
            text-align: center;
            line-height: 28px;
        }

        .notice-popup-close {
            position: absolute;
            top: 20px;
            right: 16px;
            cursor: pointer;
            width: 22px;
            height: 22px;
        }
    }

    /* 每日更新提醒卡片 */
    .notice-popup-card {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 10px 16px 0;
        padding: 0 16px;
        height: 80px;
        box-sizing: border-box;
        background: #fff;
        box-shadow: 0px 0px 16px rgba(128, 128, 128, 0.16);
        border-radius: 12px;

        .notice-popup-card-info {
            .notice-popup-card-title {
                font-size: 16px;
                font-weight: 500;
                color: #18191E;
                line-height: 22px;
            }

            .notice-popup-card-desc {
                margin-top: 4px;
                font-size: 13px;
                font-weight: 400;
                color: #858C97;
                line-height: 18px;
            }
        }

        /* 开关 */
        .notice-popup-switch {
            position: relative;
            width: 46px;
            height: 28px;
            background: #DCDDE0;
            border-radius: 14px;
            transition: background-color 0.2s;
            cursor: pointer;
            flex-shrink: 0;

            .notice-popup-switch-dot {
                position: absolute;
                top: 2px;
                left: 2px;
                width: 24px;
                height: 24px;
                background: #fff;
                border-radius: 50%;
                box-shadow: 0 1px 3px rgba(20, 26, 36, 0.2);
                transition: left 0.2s;
            }

            &.on {
                background: #FE484A;

                .notice-popup-switch-dot {
                    left: 20px;
                }
            }
        }
    }

    /* 底部提示 */
    .notice-popup-tip {
        margin: 18px 48px 0;
        font-size: 12px;
        font-weight: 400;
        color: #858C97;
        line-height: 18px;
        text-align: center;
        padding-bottom: 20px;
    }
}
</style>
